// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__cua7g","closed":"Accordion_closed__fY4dZ","body":"Accordion_body__UeBPB","trigger":"Accordion_trigger__gBQaY"};